<template>
    <div class="bg-white mb-3 p-3 rounded-10">
        <div class="flex pb-2">
            <div class="font-bold text-14 lg:text-16 text-a-brown-502314"
                :class="{'cursor-pointer': !disableSelect}"
                @click="selectAddress()">
                {{address.addressName}}
            </div>
            <img @click="onEditAddress()" class="mr-0 ml-auto cursor-pointer" src="@/assets/icon/ic-edit-brown.svg" />
        </div>
        
        <div class="text-14 lg:text-16 text-a-brown-9f8273 pb-2"
            :class="{'cursor-pointer': !disableSelect}"
            @click="selectAddress()">
            {{address.number}}
            {{address.soi}}
            {{address.building}}
            {{address.subDistrictName}}
            {{address.districtName}}
            {{address.provinceName}}
            {{address.zipcode}}
        </div>
        <div class="text-14 lg:text-16 text-a-brown-502314 pb-2"
            :class="{'cursor-pointer': !disableSelect}"
            @click="selectAddress()">
            {{address.number}}
        </div>
        <div class="flex">
            <button class="flex cursor-pointer" @click="onEditAddress()">
                <img class="ml-0 my-auto" v-if="address.isDefault" src="@/assets/icon/ic-checkbox-brown.svg" />
                <img class="ml-0 my-auto" v-else src="@/assets/icon/ic-uncheckbox-brown.svg" />
                <div class="ml-1 my-auto text-14 lg:text-16 text-a-brown-502314">{{lbl.shipping.default}}</div>
            </button>
            <button class="flex ml-6 cursor-pointer" @click="onDeleteAddress()">
                <img class="ml-0 my-auto"  src="@/assets/icon/ic-bin-red.svg" />
                <div class="ml-1 my-auto text-14 lg:text-16 text-a-red-d62300">{{lbl.shipping.delete}}</div>
            </button>
        </div>
    </div>
</template>
<script>
import LocaleMixin from "@/mixin/LocaleMixin.js";
/**
 * @event onDeleteSuccess
 */
export default {
    name: "AddressListItem",
    inject: ['DeliveryStore'],
    mixins: [LocaleMixin],
    props: {
        address: Object,
    },
    data: function() {
        return {
            disableSelect: true,
        }
    },
    created: function() {
        if (this.$route.name == "SelectAddress") {
            this.disableSelect = false;
        }
    },
    methods: {
        onDeleteAddress: function() {
            this.$emit('onDeleteAddress', this.address);
        },
        onEditAddress: function() {
            this.$emit('onEditAddress', this.address);
        },
        selectAddress: function() {
            if (!this.disableSelect) {
                this.DeliveryStore.state.delivery.address = {...this.address};
                this.$router.back();
            }
        }
    },
}
</script>
<style lang="scss" scoped>
</style>
